<template>
  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Profile</li>
      </ol>
      <div class="emp-button btn-align text-right" v-if="user && (user.type=='MANAGER' || (user.type=='EMPLOYEE' && user.managerAccess=='yes'))">
        <button type="button" data-toggle="modal" data-target="#creat-employee" class="btn btn-outline-primary">Create
          New Employee
        </button>
      </div>
    </div>
    <div class="main-box two-column">
      <employee-sidebar v-bind:employeeData="employeeId"></employee-sidebar>
      <div class="emplyee-info-wrp p-0 bg-transparent">
        <div class="approval main-box">
          <div class="text-wrapper">
            <div class="absence-text">
              <h3>Absence that needs approval</h3>
              <span>There are currently no absence that needs approval.</span>
            </div>
            <div class="filters row">
              <div class="filter-item col-md-6">
<!--                <label for="filter-year">Year</label>-->
                <select id="filter-year" class="form-select form-control" v-model="selectedYear" @change="applyFilters">
                  <option v-for="year in availableYears" :key="year" :value="year">
                    {{ year }}
                  </option>
                </select>
              </div>
              <div class="filter-item col-md-6">
<!--                <label for="filter-month">Month</label>-->
                <select id="filter-month" class="form-select form-control" v-model="selectedMonth" @change="applyFilters">
                  <option value="all">All</option>
                  <option v-for="(month, index) in months" :key="index" :value="index + 1">
                    {{ month }}
                  </option>
                </select>
              </div>
            </div>
            <div class="add-absence" v-if="user && (user.type=='MANAGER' || (user.type=='EMPLOYEE' && user.managerAccess=='yes'))">
              <a href="javascript:void(0)" class="btn btn-primary btn-sm" data-toggle="modal"
                 data-target="#leaveEntitlementModel">Add Leave Entitlement</a>
            </div>
            <div class="add-absence">
<!--              <a href="javascript:void(0)" class="btn btn-primary btn-sm" data-toggle="modal" @click="uniqueKey++"-->
              <a href="javascript:void(0)" class="btn btn-primary btn-sm" data-toggle="modal" @click="applyLeaveModel"
                 data-target="#calenModel">Apply leave</a>
            </div>

          </div>
        </div>


        <div class="table-scroll">
          <table class="table">
            <thead class="table-head">
            <tr>
              <th scope="col">Leave Type</th>
              <th scope="col">Valid From</th>
              <th scope="col">Valid To</th>
              <th scope="col">Days</th>
              <th scope="col" title="Leave Taken">Leave Taken</th>
              <th scope="col" title="Leave Balance">Leave Balance</th>
              <th :class="{ 'action-th-hidden': !isManager }" scope="col">Action</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="employeeLeaveEntitlements.length>0" v-for="employeeLeaveEntitlement in employeeLeaveEntitlements">
              <td><span class="text-capitalize">
              {{ employeeLeaveEntitlement.leave_type.name }}
              </span></td>
              <td>
                {{ employeeLeaveEntitlement.start_date | moment("D MMM YYYY") }}
              </td>
              <td>
                {{ employeeLeaveEntitlement.end_date | moment("D MMM YYYY") }}
              </td>
              <td>
                {{ employeeLeaveEntitlement.leave_allowed }}
              </td>
              <td>
                   {{ employeeLeaveEntitlement.leave_taken }}
              </td>
              <td>
<!--                   {{ (employeeLeaveEntitlement.leave_balance)}}-->
                {{ employeeLeaveEntitlement.leave_balance | toFixed2 }}
              </td>


              <td >
                <div class="actionBtn" v-if="user && (user.type=='MANAGER' || (user.type=='EMPLOYEE' && user.managerAccess=='yes'))">
                  <button class="btn btn-primary" @click="editLeaveEntitlement(employeeLeaveEntitlement)">Edit</button>
                  <button class="btn btn-danger" v-if="employeeLeaveEntitlement.leave_taken == 0" @click="deleteLeaveEntitlement(employeeLeaveEntitlement.id)">Delete</button>
                </div>
              </td>

            </tr>
            <tr v-else>
              <td colspan="3" class="text-center">No record found</td>

            </tr>
            <tr v-show="loadingSpin">
              <td colspan="6" class="text-center">
                <clip-loader :loading="loadingSpin" :size="size" :color="spinnerColor"></clip-loader>
              </td>
             </tr>
            </tbody>
          </table>
        </div>


        <div class="absence-card-holder">
          <!--          <div class="p-10" v-if="allLeaves.length === 0">No record found</div>-->
          <div class="absence-card" v-for="(lev,index) of allLeaves" :key="index">
            <div class="card-body">
              <h5 class="text-capitalize">{{ lev.userOnLeave.name }}</h5>
              <ul>
                <li><span class="col-blue">{{ new Date(lev.start_datetime).getDate() }}</span>{{
                    new Date(lev.start_datetime).toLocaleString(undefined,
                      {month: 'long'})
                  }} -
                </li>
                <li><span class="col-blue">{{ new Date(lev.end_datetime).getDate() }}</span>{{
                    new Date(lev.end_datetime).toLocaleString(undefined,
                      {month: 'long'})
                  }}
                </li>
              </ul>
              <!--              <span class="col-orange">{{ lev.type }}</span>-->
              <span class="col-orange text-capitalize" v-if="lev.companyLeaveType">
                {{ lev.companyLeaveType.name }}
                {{
                  (lev.duration_type == 'half_day') ? ' - Half Day' + ' (' + lev.is_half_day_type + ')' : (lev.duration_type == 'specify_time') ? ' - (' + lev.from_specify_time + ' - ' + lev.to_specify_time + ')' : ''
                }}
              </span>
              <span class="col-orange text-capitalize" v-else>{{ lev.type }} </span>
            </div>
            <div class="card-footer" >
              <span v-if="lev.status === 'Accept' && user.type !='EMPLOYEE' ">Approve By</span>
              <span v-else>Status</span>
              <h5 class="text-capitalize">{{ lev.status === 'Accept' && user.type !='EMPLOYEE' ? user.name : lev.status }}</h5>
              <div class="footer-btn" v-if="user && (user.type=='MANAGER' || (user.type=='EMPLOYEE' && user.managerAccess=='yes'))">
                <button type="button" class="btn btn-outline-warning " @click="itemClickShowModal(lev)" >Edit</button>
                <button type="button" class="btn btn-outline-primary" @click="deleteLeave(lev.id)">Delete</button>
              </div>
            </div>
          </div>

        </div>
        <!-- Display pagination links -->
        <div>
          <!--          <nav>
                      <ul class="pagination">
                        <li v-if="allLeavesPagination.prev_page_url">
                          <a @click="getEmployeeLeaves(allLeavesPagination.prev_page_url)">Previous</a>
                        </li>
                        <li v-if="allLeavesPagination.next_page_url">
                          <a @click="getEmployeeLeaves(allLeavesPagination.next_page_url)">Next</a>
                        </li>
                      </ul>
                    </nav>-->
          <!-- Display page numbers and navigation links -->
          <nav>
            <ul class="pagination">
              <li class="mr-10" v-if="allLeavesPagination.prev_page_url">
                <a @click="getEmployeeLeaves(allLeavesPagination.prev_page_url)">Previous</a>
              </li>
              <li v-for="page in allLeavesPagination.links" :key="page.url" :class="{ active: page.active }">
                <a v-if="page.url" @click="getEmployeeLeaves(page.url)">{{ page.label }}</a>
                <span v-else>{{ page.label }}</span>
              </li>
              <li v-if="allLeavesPagination.next_page_url">
                <a @click="getEmployeeLeaves(allLeavesPagination.next_page_url)">Next</a>
              </li>
            </ul>
          </nav>
          <!--            <pagination align="center" :data="allLeavesPagination" @pagination-change-page="allLeaves"></pagination>-->
        </div>
      </div>

    </div>

    <LeaveModels :shiftData="shiftData" :editLeave="editLeave" :leaveData="leaveData"
                 :leaveTypeWhenUpdate="selectedLeave" :leavesAllowed="leavesAllowed" :rangeUpdate="range"
                 :employeeLeaveBalance="editLeave"
                 :key="uniqueKey" :getEmployeeLeaveEntitlements ="getEmployeeLeaveEntitlements" />
    <!--leave entitlement-->
    <div
      class="modal fade add-absence-model"
      id="leaveEntitlementModel"
      tabindex="-1"
      role="dialog"
      aria-labelledby="add-absenceLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">
              <h5>Add Leave Entitlement</h5>
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <form action="">
              <div class="form-group">
                <label>Leave Types*</label>
                <select name="" class="form-control text-capitalize"
                        v-model="leaveEntitlementForm.company_leave_type_id">
                  <option value="" v-if="companyLeaveTypes" v-for="leaveType in companyLeaveTypes" :value="leaveType.id"
                          class="text-capitalize">
                    {{ leaveType.name }}
                  </option>
                </select>

              </div>
              <div class="form-group">
                <label>Start Date*</label>
                <input type="date" class="form-control" v-model="leaveEntitlementForm.start_date">
              </div>
              <div class="form-group">
                <label>End Date*</label>
                <input type="date" class="form-control" v-model="leaveEntitlementForm.end_date">
              </div>
              <div class="form-group">
                <label>Entitlement*</label>
                <input type="text" class="form-control" v-model="leaveEntitlementForm.leave_balance">
              </div>
              <div class="form-group">
                <button class="btn btn-outline-primary" @click="saveLeaveEntitlement">Save</button>
              </div>


            </form>
          </div>
        </div>
      </div>
    </div>
<!--    edit leave entitlement-->
    <div
      class="modal fade add-absence-model"
      id="editleaveEntitlementModel"
      tabindex="-1"
      role="dialog"
      aria-labelledby="add-absenceLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title">
              <h5>Edit Leave Entitlement</h5>
            </div>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span class="ico-cross"></span>
            </button>
          </div>
          <div class="modal-body">
            <form action="">
              <div class="form-group">
                <label>Leave Types*</label>
                <select name="" class="form-control text-capitalize"
                        v-model="editLeaveEntitlementForm.company_leave_type_id">
                  <option value="" v-if="companyLeaveTypes" v-for="leaveType in companyLeaveTypes" :value="leaveType.id"
                          class="text-capitalize">
                    {{ leaveType.name }}
                  </option>
                </select>

              </div>
              <div class="form-group">
                <label>Start Date*</label>
                {{editLeaveEntitlementForm.start_date}}
                <input type="date" class="form-control" v-model="editLeaveEntitlementForm.start_date">
              </div>
              <div class="form-group">
                <label>End Date*</label>
                <input type="date" class="form-control" v-model="editLeaveEntitlementForm.end_date">
              </div>
              <div class="form-group">
                <label>Days</label>
                <input type="text" class="form-control" v-model="editLeaveEntitlementForm.leave_allowed">
              </div>
              <div class="form-group">
                <label>Leave Balance</label>
                <input type="text" class="form-control" v-model="editLeaveEntitlementForm.leave_balance">
              </div>
              <div class="form-group">
                <button type="button" class="btn btn-outline-primary" @click="updateLeaveEntitlement(editLeaveEntitlementForm)">Update</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <createEmployeeModal></createEmployeeModal>
  </div>
</template>

<script>
import createEmployeeModal from "../Employees/createEmployeeModal";
import DatePicker from 'vue2-datepicker'
import employeeSidebar from "../Employees/employeeSidebar";
import LeaveModels from './leaveModals.vue';
import axios from "axios";
import moment from "moment";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';

export default {
  name: "employeeAbsence",
  components: {
    createEmployeeModal,
    DatePicker,
    employeeSidebar,
    LeaveModels,
    ClipLoader,
  },
  data() {
    return {
      leaveEntitlementForm: {
        employee_id: this.$store.getters.getEmployeeProfileId.id,
        company_leave_type_id: '',
        start_date: moment(new Date()).format('YYYY') + '-01-01',
        end_date: moment(new Date()).format('YYYY') + '-12-31',
        leave_balance: '',
      },
      editLeaveEntitlementForm: {
        id: '',
        company_id: this.$store.getters.getSelectedCompany.id,
        employee_id: this.$store.getters.getEmployeeProfileId,
        company_leave_type_id: '',
        start_date: '',
        end_date: '',
        leave_allowed: '',
        leave_balance: ''
      },

      employeeId: this.$store.getters.getEmployeeProfileId,
      user : this.$store.getters.getUser,
      leaves: [],
      allLeaves: [],
      allLeavesPagination: {},
      filteredEmployees: [],
      employees: [],
      searchEmployeeForLeave: [],
      addedRadioButton: false,
      selectedLeave: 'Vacation',
      range: '',
      range2: '',
      inputShowHide: false,
      leaveType: '',
      leaveType2: '',
      leaveData: [],
      shiftData: [],
      employeeShifts: [],
      editLeave: {},
      rangeRequired: '',
      invalidType: '',
      leaveNote: '',
      leaveNotAvailable: '',
      leaveStatusText: '',
      leaveCheckUpdate: false,
      uniqueKey: 0,
      allowedLeaves: {},
      companyLeaveTypes: [],
      employeeLeaveEntitlements: [],
      company_id: this.$store.getters.getSelectedCompany.id,
      leavesAllowed: 0,
      size: '25px',
      spinnerColor: '#00779C',
      loadingSpin: false,
      // Existing data properties
      selectedYear: new Date().getFullYear(),
      selectedMonth: new Date().getMonth() + 1,
      months: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ],
      availableYears: Array.from({ length: 10 }, (_, i) => new Date().getFullYear() - i), // Last 10 years
    }
  },
  created() {
    this.getCompanyLeaveTypes();
    this.getEmployeeLeaveEntitlements();
  },
  computed: {
      isManager() {
        return this.user &&
              (this.user.type === 'MANAGER' ||
                (this.user.type === 'EMPLOYEE' && this.user.managerAccess === 'yes'));
      }
    },
  methods: {
    applyFilters() {
      this.getEmployeeLeaveEntitlements();
      this.getEmployeeLeaves();
    },
    checkSpecifyTime(startTime, endTime) {
    },
    updateLeaveEntitlement(editLeaveEntitlementForm){
      console.log(editLeaveEntitlementForm,'editLeaveEntitlementForm');
      this.$axios.put(this.$EmployeeLeaveEntitlements+'/'+editLeaveEntitlementForm.id, editLeaveEntitlementForm, {headers: this.getAuthHeader()})
        .then(response => {
          $root.$toast.success('Updated successfully.');
          this.getEmployeeLeaveEntitlements();
          $('#editleaveEntitlementModel').modal('hide');
        })
        .catch(error => {
          console.error('Error updating holiday:', error);
        });
    },
    saveLeaveEntitlement() {
      axios.post(this.$EmployeeLeaveEntitlements, this.leaveEntitlementForm
        , {headers: this.getAuthHeader()})
        .then((res) => {
          if (res.data.status === 200) {
            $root.$toast.success(res.data.message);
            this.leaveEntitlementForm.company_leave_type_id = '';
            this.leaveEntitlementForm.leave_balance = '';
            this.getEmployeeLeaveEntitlements();
            $('#leaveEntitlementModel').modal('hide');
          }
        });
    },
    getCompanyLeaveTypes() {
      axios.get(this.$CompanyLeaveTypes, {
        headers: this.getAuthHeader(),
        params: {
          company_id: this.company_id,
        }
      })
        .then(res => {
          if (res.data.status === 200) {
            this.companyLeaveTypes = res.data.result;
          }
        });
    },
    applyLeaveModel(){
      // $('#calenModel').modal('hide');
      $('#calenModel').modal('show');
    },
    editLeaveEntitlement(employeeLeaveEntitlement){
      this.editLeaveEntitlementForm.id = employeeLeaveEntitlement.id;
      this.editLeaveEntitlementForm.employee_id = employeeLeaveEntitlement.employee_id;
      this.editLeaveEntitlementForm.company_leave_type_id = employeeLeaveEntitlement.company_leave_type_id;
      this.editLeaveEntitlementForm.start_date =moment( employeeLeaveEntitlement.start_date).format('YYYY-MM-DD') ;
      this.editLeaveEntitlementForm.end_date =moment( employeeLeaveEntitlement.end_date).format('YYYY-MM-DD');
      this.editLeaveEntitlementForm.leave_allowed = employeeLeaveEntitlement.leave_allowed;
      this.editLeaveEntitlementForm.leave_balance = employeeLeaveEntitlement.leave_balance;
      // Open the modal
      $('#editleaveEntitlementModel').modal('show');
    },
    deleteLeaveEntitlement(id) {
      axios.delete(this.$EmployeeLeaveEntitlements + '/' + id, {
        headers: this.getAuthHeader(),
      })
        .then(res => {

          if (res.data.status === 200) {
            this.getEmployeeLeaveEntitlements();
          }
        });
    },
    getEmployeeLeaveEntitlements() {
      this.loadingSpin = true;
      axios.get(this.$EmployeeLeaveEntitlements, {
        headers: this.getAuthHeader(),
        params: {
          employee_id: this.leaveEntitlementForm.employee_id,
          year: this.selectedYear, // Pass year filter
          month: this.selectedMonth // Pass month filter
        }
      })
        .then(res => {
          if (res.data.status === 200) {
            this.loadingSpin  = false;
            this.employeeLeaveEntitlements = res.data.result || [];
          }
        });
    },
    itemClickShowModal(leave) {
      this.addedRadioButton = false;
      this.inputShowHide = false;
      this.selectedLeave = '';
      this.editLeave = {
        'name': leave.userOnLeave.name,
        'type': leave.type,
        'startDate': leave.start_datetime,
        'endDate': leave.end_datetime,
        'id': leave.id,
        'emplId': leave.userOnLeave.id,
        'note': leave.body,
        'duration_type': leave.duration_type,
        'company_leave_type_id': leave.company_leave_type_id,
        'leave_balance': (leave.companyLeaveType != null)?leave.companyLeaveType.employee_leave_type_entitlement.leave_balance:0,
        'is_half_day_type': leave.is_half_day_type,
        'from_specify_time': leave.from_specify_time,
        'time_type': leave.time_type,
        'to_specify_time': leave.to_specify_time,
        'file': leave.file,
      }
      if (leave.type !== 'Vacation' && leave.type !== 'Sick') {
        this.addedRadioButton = true;
        this.leaveType2 = leave.type;
        this.selectedLeave = leave.type;
      } else {
        this.selectedLeave = 'Vacation';
      }
      this.leaveNote = leave.body;
      this.range = [new Date(leave.start_datetime), new Date(leave.end_datetime)];
      $('#itemShowModal').modal('show');
      // this.uniqueKey++;
    },
    getEmployeeLeaves(url = null) {
      this.loadingSpin  = true;
      this.$axios({
        method: "get",
        params: {
          company_id: this.$store.getters.getSelectedCompany.id,
          user_id: this.employeeId.id,
          year: this.selectedYear, // Pass year filter
          month: this.selectedMonth // Pass month filter
        },
        url: (url) ? url : this.$Getleave,
        headers: this.getAuthHeader()
      }).then(res => {
        if (res.data.status == 200) {
          this.loadingSpin = false;
          this.allLeavesPagination = res.data.result;
          this.allLeaves = res.data.result.data;
          this.leaveData['name'] = this.employeeId.name
          this.leaveData['empl_Id'] = this.employeeId.id
          this.uniqueKey++;
          this.leavesAllowed = this.employeeId.monthly_allow_leaves;
        }
      });
    },
    clearleave2() {
      this.addedRadioButton = false;
      this.inputShowHide == false
      this.selectedLeave = 'Vacation';
      this.leaveNotAvailable = '';
      this.range = '';
      document.querySelector(".modal-backdrop").remove();
      $('.period-list li.selected').removeClass('selected');
      $('.first-li').addClass('selected');
    },
    dateUpdateLeave(event) {
      if (event[0] == null) {
        this.rangeRequired = 'invalid';
        $('#edit-leave').attr('disabled', 'disabled');
        $('#consequence-leave').attr('disabled', 'disabled');
      } else {
        this.rangeRequired = '';
        $('#edit-leave').removeAttr('disabled');
        $('#consequence-leave').removeAttr('disabled');
      }
    },
    deleteLeave(id) {
      if (confirm('Are you sure you want to delete this leave?')) {
        this.$axios({
          method: 'POST',
          data: {
            'company_id': this.$store.getters.getSelectedCompany.id,
            'employee_id': this.employeeId.id,
            'id': id
          },
          url: this.$DeleteEmplLeave,
          headers: this.getAuthHeader()
        }).then((res) => {
          if (res.data.status == 200) {
            this.range = '';
            this.selectedLeave = 'Vacation';
            $('#itemShowModal').modal('hide');
            this.getEmployeeLeaves();
            this.getEmployeeLeaveEntitlements();
            $root.$toast.success('Leave deleted successfully');
          }
        });
      }
    },
    getEmployeeid() {
      this.selectedLeave = 'Vacation';
      this.$axios({
        method: "get",
        params: {
          company_id: this.$store.getters.getSelectedCompany.id,
          user_id: this.employeeId.id
        },
        url: this.$EmployeeShiftForLeave,
        headers: this.getAuthHeader()
      }).then(res => {
        if (res.data.status == 200) {
          this.shiftData = res.data.result;
       //   console.log(this.shiftData, 'getEmployeeLeaves')
        }
      });
    },
    clearleave() {
      this.addedRadioButton = false;
      this.inputShowHide == false
      this.selectedLeave = 'Vacation';
      this.range = '';
      this.rangeRequired = '';
      this.leaveNotAvailable = '';
    },
    addInputFiled() {
      if (this.inputShowHide == false) {
        this.inputShowHide = true;
      } else {
        this.inputShowHide = false;
      }
    },
    addRadio() {
      if (this.leaveType !== '') {
        this.leaveType2 = this.leaveType;
        this.selectedLeave = this.leaveType2;
        this.addedRadioButton = true;
        $('.leeave-type').prop("checked", true);
        this.inputShowHide = false;
        this.leaveType = ''
        this.invalidType = '';
        $('#edit-leave').removeAttr('disabled');
        $('#consequence-leave').removeAttr('disabled');
      } else {
        this.invalidType = 'invalid';
        $('#edit-leave').attr('disabled', 'disabled');
        $('#consequence-leave').attr('disabled', 'disabled')
      }
    },
    getAllEmployees() {
      this.$axios({
        method: "get",
        params: {
          company_id: this.$store.getters.getSelectedCompany.id,
          filter_by: "EMPLOYEE"
        },
        url: this.$GetEmployees,
        headers: this.getAuthHeader()
      }).then(res => {
        if (res.data.status == 200) {
          this.filteredEmployees = res.data.result;
          this.employees = this.filteredEmployees;
          this.searchEmployeeForLeave = this.filteredEmployees;
        }
      });
    }
  },
  mounted() {
    // this.getAllEmployees();
    this.getEmployeeLeaves();
    this.getEmployeeid();
    this.$root.$on("refreshLeaves", () => {
      this.getEmployeeLeaves();
    });
    this.$root.$on("refreshCompo", () => {
      this.uniqueKey++;
    });
  },

}

</script>

<style>
.action-th-hidden{
  visibility: hidden;
}

</style>
